import React, { Children } from 'react';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
const bookingOptions = [{
  title: 'Book a Table',
  subtitle: 'RESERVATIONS',
  description: 'Secure your spot for an unforgettable evening of dining and nightlife.',
  image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=800',
  action: 'Reserve Now'
}, {
  title: 'Order Food',
  subtitle: 'PICKUP & DELIVERY',
  description: 'Experience our signature Ethiopian-inspired flavors from the comfort of your home.',
  image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?auto=format&fit=crop&q=80&w=800',
  action: 'View Menu & Order'
}, {
  title: 'Catering',
  subtitle: 'LARGE ORDERS',
  description: 'Elevate your external events with our curated selection of boutique bar bites and signature plates.',
  image: 'https://images.unsplash.com/photo-1551024709-8f23befc6f87?auto=format&fit=crop&q=80&w=800',
  action: 'Request Catering'
}, {
  title: 'Private Events',
  subtitle: 'VENUE PRIVATIZATION',
  description: "Host your grand celebrations or intimate gatherings in the capital's most exclusive setting.",
  image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&q=80&w=800',
  action: 'Contact Concierge'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function Booking() {
  return <main className="bg-obsidian min-h-screen" data-id="element-176">
      <div className="pt-24 md:pt-32 pb-20 px-6 md:px-8 max-w-7xl mx-auto" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-16 md:mb-24" data-id="element-178">
          <span className="text-xs md:text-sm tracking-[0.4em] text-crimson uppercase font-sans mb-4 block" data-id="element-179">
            Your Experience Awaits
          </span>
          <h1 className="text-5xl md:text-8xl font-serif text-champagne mb-6" data-id="element-180">
            RESERVATIONS
          </h1>
          <p className="text-white/60 font-sans text-xl md:text-2xl max-w-2xl mx-auto" data-id="element-181">
            Select an option below to book your table, order our signature
            dishes, or plan your next exclusive event.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" animate="show" className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-182">
          {bookingOptions.map((option, idx) => <motion.div key={idx} variants={itemVariants} className="group cursor-pointer h-full" data-id="element-183">
              <div className="relative h-[400px] md:h-[450px] w-full overflow-hidden border border-white/10 bg-obsidian transition-all duration-500 hover:border-crimson hover:shadow-[0_0_30px_rgba(219,32,39,0.15)] flex flex-col justify-end p-8 md:p-10" data-id="element-184">
                {/* Background Image */}
                <img src={option.image} alt={option.title} className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-30 group-hover:scale-110 transition-all duration-700 ease-out" data-id="element-185" />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/60 to-transparent opacity-90" data-id="element-186" />

                {/* Content */}
                <div className="relative z-10 transform transition-transform duration-500 group-hover:-translate-y-2" data-id="element-187">
                  <span className="text-[10px] tracking-[0.4em] text-champagne uppercase font-sans mb-3 block" data-id="element-188">
                    {option.subtitle}
                  </span>
                  <h3 className="text-3xl md:text-4xl font-serif text-white mb-4 group-hover:text-crimson transition-colors duration-300" data-id="element-189">
                    {option.title}
                  </h3>
                  <p className="text-white/60 font-sans text-base leading-relaxed mb-8" data-id="element-190">
                    {option.description}
                  </p>

                  <button className="px-8 py-4 border border-champagne text-xs uppercase tracking-[0.3em] font-serif text-champagne group-hover:bg-crimson group-hover:border-crimson group-hover:text-white transition-all duration-500 shadow-[0_0_15px_rgba(197,160,89,0.1)] group-hover:shadow-[0_0_20px_rgba(219,32,39,0.4)]" data-id="element-191">
                    {option.action}
                  </button>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
      <Footer data-id="element-192" />
    </main>;
}